import type { QueryClient } from '@tanstack/react-query';
import { persistQueryClientRestore } from '@tanstack/react-query-persist-client';
import { createQueryClient } from './queryClient';
import {
  createQueryPersister,
  type AppQueryPersister,
} from './queryPersistOptions';
import { QUERY_PERSIST_MAX_AGE_MS } from './queryPersistConstants';

export type BootstrappedQueryClient = {
  queryClient: QueryClient;
  persister: AppQueryPersister;
};

/**
 * Restores persisted cache from localStorage into a new {@link QueryClient} **before** the first
 * React render. Pair with {@link QueryProvider} using the same `queryClient` and `persister`.
 */
export async function bootstrapPersistedQueryClient(): Promise<BootstrappedQueryClient> {
  const queryClient = createQueryClient();
  const persister = createQueryPersister();

  try {
    await persistQueryClientRestore({
      queryClient,
      persister,
      maxAge: QUERY_PERSIST_MAX_AGE_MS,
    });
  } catch (error) {
    console.error('[query-cache] Failed to restore persisted cache', error);
  }

  return { queryClient, persister };
}
